// @flow

import * as React from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
  addCartProduct,
  removeCartProducts,
  selectCartUUID,
  selectProductsByTypeAndProcess,
  updateCartProduct,
} from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base, Spinner } from '@gandi/ui';

import { useQuery } from 'src/helpers/withRouter';
import { useAppSelector } from 'src/hooks/useAppSelector';

import { Intro } from '../../Layout/components/Intro';
import { Layout } from '../../components/Layout';
import type { Quotation } from '../../modules/cloud/resources/quotations';
import AddCredit from '../components/AddCredit';
import Consumption from '../components/Consumption';
import { useTemplates } from '../modules/templates';

export type Query = {
  /**
   * seems to be a "templateQuerystring" …
   */
  t?: string,
};

const productSelectorProps = {
  productType: 'cloud',
  process: 'add',
};

function Extend(): React.Node {
  const translator = useTranslator();
  const { __ } = translator;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const query = useQuery<Query>();

  const cartId = useAppSelector(selectCartUUID);
  const [product, ...cloudProducts] = useAppSelector(state =>
    selectProductsByTypeAndProcess(state, productSelectorProps),
  );
  const templateQuerystring = query.t;
  const {
    isFetchingTemplates,
    fetchTemplatesParams,
    shouldFetchTemplates,
    templates,
  } = useTemplates();
  const template = templateQuerystring
    ? templates?.find(t => t.name === decodeURIComponent(templateQuerystring))
    : undefined;

  async function handleAddToCart(quotation: Quotation) {
    const body = {
      product_type: 'cloud',
      process: 'add',
      payload: {
        label: __('Funds added to Cloud Account'),
        amount:
          quotation.prices[0].normal_price_after_taxes ||
          quotation.prices[0].price_after_taxes,
        dateExhaust: quotation.prices[0].date_exhaust,
        mode: quotation.prices[0].mode,
        ...fetchTemplatesParams,
      },
    };

    if (cloudProducts.length) {
      if (cloudProducts.length) {
        // $FlowFixMe[prop-missing]
        await dispatch(removeCartProducts(cloudProducts));
      }
    }

    if (product) {
      return dispatch(
        // $FlowFixMe[incompatible-call]
        // $FlowFixMe[prop-missing]
        updateCartProduct({ productId: product.id, payload: body.payload }),
      ).then(() => {
        navigate(`/cart/${cartId}`);
      });
    }

    // $FlowFixMe[incompatible-call]
    // $FlowFixMe[prop-missing]
    return dispatch(addCartProduct({ productData: body })).then(() => {
      navigate(`/cart/${cartId}`);
    });
  }

  return (
    <Layout>
      <Intro title={__('Credit your Cloud Account')} />
      {(shouldFetchTemplates || isFetchingTemplates) && !templates ? (
        <Spinner centered />
      ) : (
        <>
          <Base marginBottom="base">
            <Consumption additionalPrice={template?.price.price_after_taxes} />
          </Base>
          <AddCredit
            // $FlowFixMe[incompatible-type]
            mode={product?.payload.mode}
            onAddToCart={handleAddToCart}
            server={
              template
                ? {
                    cores: template.server.cores,
                    memory: template.server.memory,
                    ips: template.server.ips,
                    volumes: template.server.volumes,
                  }
                : undefined
            }
          />
        </>
      )}
    </Layout>
  );
}

export default Extend;
